import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { withTranslation } from 'react-i18next';

import DivButton from '../button/DivButton';

import {
  checkedCurrencySymbol,
  settingCost,
  getPerItemCouponCost,
  returnComma,
  getAddonTitle,
  getAddonPrice,
} from '../../common/Utils';

const trash = '/svg/trash.svg';
const addIcon = '/svg/info.svg';

function renderOpt(otp) {
  if (otp.length === 0) return null;

  const arr = otp.map((item, i) => (<div
    key={shortid.generate()}
    className="cart-item-option-row"
    style={styles.optionBox}
  >
    <p className="cart-item-option-key" style={styles.keyTitle}>{item.title}</p>
    <p className="cart-item-option-value" style={styles.optValue}>{item.context}</p>
  </div>));

  return (<div className="cart-item-options" style={styles.otpContainer}>
    {arr}
  </div>);
}

function renderCoupon(data, couponData, i18n) {
  if (!couponData) return null;
  const perCouponCost = getPerItemCouponCost(data, couponData, i18n.language);

  if (perCouponCost > 0) {
    const cost = `${checkedCurrencySymbol(i18n.language)}${i18n.language === 'en' ? returnComma((settingCost(i18n.language, data) - perCouponCost).toFixed(2)) : returnComma(settingCost(i18n.language, data) - perCouponCost)}`;
    return cost;
  }

  return null;
}

class MyCartItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      inputQty: props.quantity,
      addOptionsBtnHover: false,
    };
  }

  render() {
    const { data, i18n, coupon } = this.props;
    // console.log(coupon, JSON.parse(data.body));

    return (
      <div className="cart-item-container" style={styles.container(this.props.marginBottom)}>
        <div className="cart-item-inner" style={styles.innerContainer(this.props.marginBottom !== 0)}>
          <img
            alt=""
            className="cart-item-img"
            style={styles.img}
            src={data.uri_pd}
          />

          <div className="cart-item-center" style={styles.centerBox}>

            {
              data.b_custom === 1 ? <div className="cart-item-customize-box" style={styles.cutomizeTitleBox}>
                <p style={styles.title}>Customize</p>
                <div className="cart-item-action-buttons" style={styles.actionButtons}>
                  <u
                    onClick={() => this.props.onViewDtail()}
                    role="button"
                    tabIndex="-1"
                    style={styles.viewDetailText}
                  >
                    View Detail
                  </u>
                  <DivButton
                    style={styles.addOptionsBtn(this.state.addOptionsBtnHover)}
                    onClick={() => this.props.onAddOptions()}
                    onMouseEnter={() => this.setState({ addOptionsBtnHover: true })}
                    onMouseLeave={() => this.setState({ addOptionsBtnHover: false })}
                  >
                    <span>{this.props.t('addOptions') || 'Upgrade Your Glove'}</span>
                    <span style={styles.addOptionsBtnArrow}>{'>'}</span>
                  </DivButton>
                </div>
              </div>
              : <p style={styles.title}>{JSON.parse(data.body).title}</p>
            }

            { renderOpt(JSON.parse(data.body).options) }

            {/* 추가옵션 정보 표시 */}
            {data.b_custom === 1 && this.props.addonData && this.props.addonData.addons && this.props.addonData.addons.length > 0 && (
              <div style={styles.addonInfoBox}>
                <p style={styles.addonInfoTitle}>{this.props.t('addonOptions') || 'Add-on Options'}</p>
                {this.props.addonData.addons.map((addon, idx) => (
                  <div key={idx} style={styles.addonRow}>
                    <span style={styles.addonName}>{getAddonTitle(addon, i18n.language)}</span>
                    <span style={styles.addonPrice}>
                      {checkedCurrencySymbol(i18n.language)}
                      {i18n.language === 'en'
                        ? returnComma(getAddonPrice(addon, i18n.language).toFixed(2))
                        : returnComma(getAddonPrice(addon, i18n.language))}
                    </span>
                  </div>
                ))}

                {/* 참고 이미지 */}
                {this.props.addonData.addon_ref_imgs && this.props.addonData.addon_ref_imgs.length > 0 && (
                  <div style={styles.addonRefSection}>
                    <p style={styles.addonRefTitle}>{this.props.t('addonRefImages') || 'Reference Images'}</p>
                    <div style={styles.addonRefImages}>
                      {this.props.addonData.addon_ref_imgs.map((img, idx) => (
                        <img key={idx} src={img.url} alt={`ref-${idx}`} style={styles.addonRefImg} />
                      ))}
                    </div>
                  </div>
                )}

                {/* Additional Request */}
                {this.props.addonData.addon_request && (
                  <div style={styles.addonRefSection}>
                    <p style={styles.addonRefTitle}>{this.props.t('addonRequest') || 'Additional Request'}</p>
                    <p style={styles.addonRequestText}>{this.props.addonData.addon_request}</p>
                  </div>
                )}
              </div>
            )}

            <div className="cart-item-counter" style={styles.counterBox(JSON.parse(data.body).options.length === 0)}>
              <p style={styles.qtyText}>QTY</p>

              <input
                type="number"
                onChange={e => this.setState({ inputQty: Number(e.target.value) > 0 ? e.target.value : 1 })}
                min={1}
                value={this.state.inputQty}
                style={styles.qtyInput}
              />
              <DivButton
                style={styles.updateBtn}
                onClick={() => this.props.onCalculation(this.state.inputQty)}
              >
                Update
              </DivButton>
            </div>

          </div>

          <div className="cart-item-right" style={styles.rightBox}>
            <p style={styles.cost(renderCoupon(data, coupon, i18n))}>
              {checkedCurrencySymbol(i18n.language)}
              {i18n.language === 'en' ? returnComma(settingCost(i18n.language, data).toFixed(2)) : returnComma(settingCost(i18n.language, data))}
            </p>
            <p style={styles.couponText}>
              {renderCoupon(data, coupon, i18n)}
            </p>
            <div
              role="button"
              tabIndex="-1"
              style={styles.trashBox}
              onClick={() => this.props.onDelete()}
            >
              <img
                src={trash}
                alt=""
                style={styles.trash}
              />
            </div>

          </div>
        </div>
      </div>
    );
  }
}

MyCartItem.propTypes = {
  marginBottom: PropTypes.number,
  data: PropTypes.object,
  onDelete: PropTypes.func,
  quantity: PropTypes.number,
  onCalculation: PropTypes.func,
  i18n: PropTypes.object,
  onViewDtail: PropTypes.func,
  coupon: PropTypes.object,
  onAddOptions: PropTypes.func,
  hasAddon: PropTypes.bool,
  highlightAddon: PropTypes.bool,
  addonData: PropTypes.object,
  t: PropTypes.func,
};

MyCartItem.defaultProps = {
  marginBottom: 24,
  data: {},
  onDelete: () => {},
  quantity: 1,
  onCalculation: () => {},
  i18n: {},
  onViewDtail: () => {},
  coupon: null,
  onAddOptions: () => {},
  hasAddon: false,
  highlightAddon: false,
  addonData: null,
  t: (key) => key,
};

const styles = {
  container: marginBottom => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom,
    padding: '0 24px',
    boxSizing: 'border-box',
  }),
  innerContainer: isBorder => ({
    width: '100%',
    maxWidth: 624,
    display: 'flex',
    borderBottom: isBorder ? '2px solid rgba(37, 31, 27, 0.12)' : 'none',
    boxSizing: 'border-box',
    MozBoxSizing: 'border-box',
    WebkitBoxSizing: 'border-box',
    paddingBottom: 22,
  }),
  img: {
    width: 98,
    height: 98,
  },
  centerBox: {
    flex: 1,
    minWidth: 0,
    marginLeft: 24,
  },
  title: {
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    fontWeight: 600,
    color: '#251f1b',
  },
  counterBox: isMarginTop => ({
    display: 'flex',
    alignItems: 'center',
    marginTop: isMarginTop ? 48 : 0,
  }),
  qtyText: {
    fontFamily: 'Roboto Condensed',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 1.38,
    letterSpacing: 1,
    color: '#251f1b',
  },
  rightBox: {
    width: 88,
    flexShrink: 0,
    marginLeft: 14,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    position: 'relative',
  },
  cost: isCoupon => ({
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    letterSpacing: 0.9,
    textAlign: 'right',
    color: '#251f1b',
    fontWeight: 'bold',
    textDecoration: isCoupon ? 'line-through' : 'none',
  }),
  trashBox: {
    width: '100%',
    height: 30,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  trash: {
    cursor: 'pointer',
  },
  optionBox: {
    display: 'flex',
    marginBottom: 4,
  },
  keyTitle: {
    flex: 1,
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    color: '#251f1b',
    lineHeight: 1.57,
    opacity: 0.4,
  },
  optValue: {
    flexShrink: 0,
    textAlign: 'right',
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    color: '#251f1b',
    lineHeight: 1.57,
  },
  otpContainer: {
    marginBottom: 24,
    marginTop: 16,
  },
  cutomizeTitleBox: {
    width: '100%',
    maxWidth: 220 + 140,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 8,
  },
  viewDetailText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#c77b46',
    lineHeight: 1.14,
    cursor: 'pointer',
    outline: 'none',
  },
  addOptionsBtn: (isHover) => ({
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '7px 32px 7px 20px',
    minWidth: 170,
    backgroundColor: isHover ? '#b71c1c' : '#d32f2f',
    color: '#fff',
    fontSize: 14,
    fontWeight: 700,
    borderRadius: 4,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    letterSpacing: 0.3,
    textAlign: 'center',
  }),
  addOptionsBtnArrow: {
    position: 'absolute',
    right: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1,
  },
  addonInfoBox: {
    marginTop: 12,
    paddingTop: 8,
    marginBottom: 12,
  },
  addonInfoTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#251f1b',
    margin: '0 0 8px',
    fontFamily: 'Roboto Condensed',
  },
  addonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  addonName: {
    fontSize: 13,
    color: '#251f1b',
    fontFamily: 'Roboto Condensed',
  },
  addonPrice: {
    fontSize: 13,
    color: '#c77b46',
    fontFamily: 'Roboto Condensed',
    fontWeight: '600',
  },
  addonRefSection: {
    marginTop: 16,
  },
  addonRefTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: '#251f1b',
    margin: '0 0 6px',
    fontFamily: 'Roboto Condensed',
  },
  addonRefImages: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
  },
  addonRefImg: {
    width: 60,
    height: 60,
    objectFit: 'cover',
    borderRadius: 4,
    border: '1px solid #ddd',
  },
  addonRequestText: {
    fontSize: 13,
    color: '#251f1b',
    fontFamily: 'Roboto Condensed',
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  qtyInput: {
    width: 48,
    height: 30,
    border: 'solid 1px #251f1b',
    color: '#251f1b',
    lineHeight: 1.14,
    fontWeight: '600',
    fontSize: 14,
    textAlign: 'center',
    outline: 'none',
    marginLeft: 40,
  },
  updateBtn: {
    width: 64,
    height: 30,
    backgroundColor: '#251f1b',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 1.67,
    marginLeft: 16,
  },
  couponText: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'right',
    color: '#d0021b',
    position: 'absolute',
    top: 16,
    right: 0,
  },
};

export default withTranslation('translations')(MyCartItem);
